import { default as LogoWhiteIcon } from "@/assets/icons/logo_white.svg?react";
import styles from "./styles.module.scss";
import classNames from "classnames";
import { useAppState } from "@/modules/app/useAppContext";

const AltimateProfileImage = () => (
  <div className={styles.ai_profile_image}>
    <LogoWhiteIcon />
  </div>
);

type ProfileImageSize = "xs" | "sm" | "md" | "lg" | "xl";

const sizeClassMap: Record<ProfileImageSize, string> = {
  xs: styles.xs,
  sm: styles.sm,
  md: styles.md,
  lg: styles.lg,
  xl: styles.xl,
};

const UserProfileImage = ({
  size = "md",
  bgColor = "#004fbf",
}: {
  size?: ProfileImageSize;
  bgColor?: string;
}) => {
  const { loggedinUser: user } = useAppState();
  return (
    <div
      className={classNames(styles.user_profile_image, sizeClassMap[size])}
      style={{ backgroundColor: bgColor }}
    >
      {(user?.first_name?.[0] || "") + (user?.last_name?.[0] || "")}
    </div>
  );
};

export { AltimateProfileImage, UserProfileImage };
